import { css } from "emotion";
import React from "react";
import {
  Button,
  Card,
  Container,
  Graph,
  Scroll,
  Section,
  Text,
} from "../../components";
import { BACKGROUND } from "../../constants";

const sampleResults = [
  {
    top: 19,
    bottom: -8,
    avg: 3,
    score: 5,
    format: (n) => n + "%",
    title: "Attendance Growth",
  },
  {
    top: 121,
    bottom: 42,
    avg: 75,
    score: 51,
    format: (n) => n + ":1",
    title: "Attendance to Staff",
  },
  {
    top: 15,
    bottom: 5,
    avg: 9.5,
    score: 8,
    format: (n) => n + "%",
    title: "Percentage of Students",
  },
  {
    top: 1.13,
    bottom: 0.1,
    avg: 0.6,
    score: 0.4,
    format: (n) => n + ":1",
    title: "Guests to Attendance",
  },
];

const sampleQuotes = [
  {
    image: require("../../assets/images/worship.png"),
    text: `This became a turning point for our Leadership Team and Congregation - thanks @UnstuckGroup for your resources - they have helped to clear a path so that we can move forward.`,
    byline: "Les Burrows, Area Commander, The Salvation Army Canada",
  },
  {
    image: require("../../assets/images/worship.png"),
    text: `This became a turning point for our Leadership Team and Congregation!`,
    byline: "Les Burrows, Area Commander, The Salvation Army Canada",
  },
  {
    image: require("../../assets/images/worship.png"),
    text: `This became a turning point for our Leadership Team and Congregation!`,
    byline: "Les Burrows, Area Commander, The Salvation Army Canada",
  },
  {
    image: require("../../assets/images/worship.png"),
    text: `This became a turning point for our Leadership Team and Congregation - thanks @UnstuckGroup for your resources - they have helped to clear a path so that we can move forward.`,
    byline: "Les Burrows, Area Commander, The Salvation Army Canada",
  },
];

const Home = () => {
  return (
    <div>
      <header>
        <Section
          className={css`
            overflow: hidden;
          `}
        >
          <Container
            className={css`
              display: flex;
              align-items: center;
              @media (max-width: 800px) {
                flex-direction: column;
              }
            `}
          >
            <div>
              <Text.H1>Assess your church's health today.</Text.H1>
              <br />
              <Text.Large leading="copy" measure>
                The work of ministry can turn into a whirlwind of activity, and
                attempts to gauge how well you are doing can feel like trying to
                check the oil of a speeding car. With the{" "}
                <i>Vital Signs Assessment</i>, you get an unbiased snapshot of
                your church’s health today. It’s packed with benchmarks from the
                analysis of 300+ churches nationwide that will give you a
                healthier scorecard for ministry.
              </Text.Large>
              <br />
              <Button kind="secondary" to="/signin">
                Get Started
              </Button>
            </div>
            <div>
              <img
                src={require("../../assets/images/ui.png")}
                className={css`
                  flex-shrink: 0;
                  margin: -50px 25px -50px 0;
                  width: 140%;
                  height: auto;
                  min-height: 300px;
                  @media (max-width: 800px) {
                    margin: 50px 0 -50px;
                  }
                `}
              />
            </div>
          </Container>
        </Section>
      </header>

      <Section
        className={css`
          background-color: ${BACKGROUND};
        `}
      >
        <Container>
          <Text.H3>Detailed results for 20+ church health metrics:</Text.H3>
        </Container>
        <Scroll horizontal={true} vertical={false}>
          <Container>
            <ul
              className={css`
                margin: 0 -20px;
                padding: 10px;
                list-style: none;
                display: flex;
                align-items: stretch;
              `}
            >
              {sampleResults.map((sampleResult, index) => (
                <li
                  key={index}
                  className={css`
                    flex-shrink: 0;
                    padding: 10px;
                    text-align: center;
                    display: flex;
                    align-items: stretch;
                  `}
                >
                  <Card
                    className={css`
                      padding: 50px;
                    `}
                  >
                    <Graph {...sampleResult} />
                    <br />
                    <Text.H5>{sampleResult.title}</Text.H5>
                  </Card>
                </li>
              ))}
            </ul>
          </Container>
        </Scroll>
      </Section>

      {/* <Section>
        <Container>
          <Text.H3>A growing base of successful churches:</Text.H3>
        </Container>
        <Scroll horizontal={true} vertical={false}>
          <Container>
            <ul
              className={css`
                margin: 0 -20px;
                padding: 10px;
                list-style: none;
                display: flex;
                align-items: stretch;
              `}>
              {sampleQuotes.map((sampleQuote, index) => (
                <li
                  key={index}
                  className={css`
                    flex-shrink: 0;
                    padding: 10px;
                  `}>
                  <Card
                    className={css`
                      height: 200px;
                      display: flex;
                      align-items: stretch;
                    `}>
                    <img
                      src={sampleQuote.image}
                      className={css`
                        height: 200px;
                        width: 200px;
                        object-fit: cover;
                        border-radius: 10px 0 0 10px;
                      `}
                    />
                    <div
                      className={css`
                        width: ${sampleQuote.text.length * 2}px;
                        min-width: 300px;
                        padding: 20px;
                      `}>
                      <Text.Small leading="copy">{sampleQuote.text}</Text.Small>
                      <hr
                        style={{
                          border: "none",
                          height: 1,
                          backgroundColor: SECONDARY_TEXT,
                        }}
                      />
                      <Text.Small style={{ color: SECONDARY_TEXT }}>
                        {sampleQuote.byline}
                      </Text.Small>
                    </div>
                  </Card>
                </li>
              ))}
            </ul>
          </Container>
        </Scroll>
      </Section> */}

      <Section
        className={css`
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center 30%;
          background-image: url(${require("../../assets/images/worship.png")});
        `}
      >
        <Container
          className={css`
            text-align: center;
            color: white;
          `}
        >
          <Text.H1>
            Assess your church’s <br />
            health today.
          </Text.H1>
          <br />
          <br />
          <Button kind="secondary" to="/signin">
            Get Started
          </Button>
        </Container>
      </Section>

      <footer>
        <Section>
          <Container>
            <div
              className={css`
                display: flex;
                justify-content: space-between;
                @media (max-width: 800px) {
                  align-items: flex-start;
                  flex-direction: column;
                  img {
                    margin-bottom: 50px;
                  }
                }
              `}
            >
              <img
                src={require("../../assets/images/logo.png")}
                alt="The Unstuck Group"
                role="logo"
                className={css`
                  height: 40px;
                `}
              />
              <Text measure>
                The Vital Signs Assessment is just one tool{" "}
                <b>The Unstuck Group</b> uses to help churches assess ministry
                health and get a fresh perspective.
                <br />
                <br />
                Learn more about the full{" "}
                <a
                  href="https://theunstuckgroup.com/church-consulting/"
                  target="_blank"
                >
                  Unstuck Process
                </a>
                .
              </Text>
            </div>
          </Container>
        </Section>
      </footer>
    </div>
  );
};

Home.displayName = "Home";

export default Home;



// WEBPACK FOOTER //
// ./src/screens/home/Home.js